import Header from "../../components/Header/Header"
import SearchInvoice from "../../components/Body/SearchInvoice/SearchInvoice";
import Footer from "../../components/Footer/Footer";
import MinvoiceProduct from "../../components/Body/Slide/MinvoiceProduct";
import ThirdtyPartner from "../../components/Body/Slide/ThirdtyPartner";
import { Col, Layout, Menu, Row } from "antd";
import './SearchInvoice.css'
import HeaderData from '../../data/SearchInvoice/header'
import React, { memo } from "react";
const SearchInvoiceScreen: React.FC = () => {
    return (
                <Layout>
                    <Header CustomHeader={() =>
                    (
                        <Row>
                            <Col xs={12} md={12} style={{ border: "none" }}>
                                <Menu className="search-invoice-header-center-menu">
                                    <Menu.Item key="tra-cuu-mat-hang-giam-thue-nghi-dinh-44-2023-nd-cp" danger>
                                        <a href={`/tra-cuu-mat-hang-giam-thue-nghi-dinh-44-2023-nd-cp`} target="_blank">Tra cứu mặt hàng giảm thuế theo Nghị định 44/2023/NĐ-CP</a>
                                    </Menu.Item>
                                </Menu>
                            </Col>
                            <Col xs={12} md={12} style={{ border: "none" }}>
                                <Menu
                                    className="search-invoice-header-left-menu"
                                    mode="horizontal"
                                    selectable={false}
                                    items={HeaderData.CenterMenu}
                                />
                            </Col>

                        </Row>
                    )}
                        customHeaderProps={{
                            // display: "flex",
                            // justifyContent: "end"
                        }}
                    />
                    <SearchInvoice />
                    <MinvoiceProduct></MinvoiceProduct>
                    <ThirdtyPartner></ThirdtyPartner>
                    <Footer />
                </Layout>   
    )
}
export default memo(SearchInvoiceScreen);